import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input, Select } from "../../../components/form";
import { Button } from "../../../components/button";
import { useCategories } from "../../categories/hooks";

interface ICustomerForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const CustomerForm: React.FC<ICustomerForm> = ({
  loading,
  form,
  submit,
}) => {
  const { data } = useCategories();

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Input
          label="Nom"
          className="w-full"
          {...form.register("name", { required: "Nom requis" })}
          placeholder="Nom du client"
        />
        <Input
          label="Email"
          className="w-full"
          {...form.register("email")}
          placeholder="contact@client.fr"
        />
        <Input
          label="Siren"
          className="w-full"
          maxLength={9}
          {...form.register("siren")}
          placeholder="123456789"
        />
        <Input
          label="Téléphone"
          className="w-full"
          {...form.register("phone")}
          placeholder="+33..."
        />
        <Select label="Catégorie" className="w-full" {...form.register("categoryId")}>
          <option value="">-</option>
          {data?.categories?.results?.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </Select>
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
